<template>
    <div class="row">
        <div class="col-md-6">
            <multiselect
                v-model="filterCategories"
                :options="allCategories"
                :multiple="true"
                track-by="id"
                :allow-empty="true"
                label="name"
                placeholder="--filter by venue category--"
            ></multiselect>
        </div>
        <div class="col-md-6">
            <multiselect
                v-model="filterProductTypes"
                :options="allProductTypes"
                :multiple="true"
                track-by="code"
                :allow-empty="true"
                label="name"
                placeholder="--filter by product type--"
            ></multiselect>
        </div>
            <div class="col-md-6">
                <multiselect
                    v-model="filterDeals"
                    :options="alldeals"
                    :multiple="true"
                    track-by="id"
                    :allow-empty="true"
                    label="name"
                    placeholder="--filter by deal--"
                ></multiselect>
            </div>
            <div class="col-md-6">
                <multiselect
                    v-model="filterRedemptionValidation"
                    :options="allRedemptionValidation"
                    :multiple="true"
                    track-by="id"
                    :allow-empty="true"
                    label="name"
                    placeholder="--filter by redemption validation--"
                ></multiselect>
            </div>
        <div class="col-md-12">
            <div >
                All check-ins assigned <input style="width: fit-content;display: inline;" maxlenght="6" size="6" id="all_checkin_points" name="all_checkin_points" class="form-control" type="text" v-model.number="all_checkin_points"/> points
                <span class="invalid-feedback" style="display: block;" v-if="errors.all_checkin_points">@{{ errors.all_checkin_points }}</span>
            </div>
        </div>
        <div class="col-md-12">
            <div >
                All standard redemptions assigned <input style="width: fit-content;display: inline;" maxlenght="6" size="6" id="all_standard_redemptions" name="all_standard_redemptions" class="form-control" type="text" v-model.number="all_standard_redemptions"/> points
                <span class="invalid-feedback" style="display: block;" v-if="errors.all_standard_redemptions">@{{ errors.all_standard_redemptions }}</span>
            </div>
        </div>
        <div class="col col-md-12">
          <v-expansion-panels v-model="panelId">
            <v-expansion-panel
                v-for="(deal, idx) in dealsWithProductsFiltered"
                :key="deal.id"
                :value="idx"
                :title="deal.name"
            >
              <v-expansion-panel-header>
                {{ deal.name }}
                <template v-slot:actions>
                  <icon
                      class="mdi mdi-menu-down"
                      :class="panelId === idx ? 'mdi-menu-up' : 'mdi-menu-down'">
                  </icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="block-content">
                  <div class="row" v-if="deal.id > 0">
                    <label for="expire_points" class="control-label
												col-lg-3">Points expire at end of deal:</label>

                    <div class="controls col-lg-6">
                      <select class="input-mini form-control" id="expire_points" :value="getExpiration(deal.id)"
                              @input="setExpiration(deal.id, $event.target.value)">
                        <option :value="false">No</option>
                        <option :value="true">Yes</option>
                      </select>
                      <span class="font-size-sm text-muted"></span>
                    </div>
                  </div>
                  <div class="row" v-for="product in sortedProducts(deal.products)">
                    <div class="col-md-3">
                      <input class="form-control" @keypress="isNumber($event)" :value="getPoints(deal.id, product.id)"
                             @input="setPoints(deal.id, product.id, $event.target.value)"/>
                    </div>
                    <div class="col-md-9">
                      {{ (allProductsById[product.id]?.venueName || `Venue ${product.venue_id}`) + ' - ' + product.name }}
                    </div>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

        </div>
    </div>
</template>

<script>
    const ALL_REDEMPTION_VALIDATION = [
        {
            id: '',
            name: 'None'
        },
        {
            id: 'pin',
            name: 'Pin'
        },
        {
            id: 'gps',
            name: 'Gps'
        },
        {
            id: 'gpsOrPin',
            name: 'Gps or Pin'
        }
    ];


    export default {
        props: {
            alldeals: Array,
            allproducts: Array,
            deals: Array,
            products: Array,
            rule: Object,
            venues: Array,
        },
        data: () => ({
          allRedemptionValidation: ALL_REDEMPTION_VALIDATION,
          filterCategories: [],
          filterDeals: [],
          filterProductTypes: [],
          filterRedemptionValidation: [],
          expire_at_end: [],
          errors: {},
          panelId: null
        }),
        methods: {
            setDefaultModel(dealId) {
                if (!this.rule.settings.dealProducts) {
                    this.$set(this.rule.settings, 'dealProducts', {});
                }
                if (!this.rule.settings.dealProducts[dealId]) {
                    this.$set(this.rule.settings.dealProducts, dealId, {});
                }
            },
            setPoints(dealId, productId, points) {
                if (!/^\d+$/.test(points)) {
                    points = '';
                }

                this.setDefaultModel(dealId);
                this.$set(this.rule.settings.dealProducts[dealId], productId, parseInt(points) || undefined );
            },
            getPoints(dealId, productId) {
                return this.rule.settings.dealProducts?.[dealId]?.[productId];
            },
            setExpiration(dealId, value) {
                this.setDefaultModel(dealId);
                this.$set(this.rule.settings.dealProducts[dealId], 'expire_at_end', value == 'true');
            },
            getExpiration(dealId) {
                return this.rule.settings.dealProducts?.[dealId]?.expire_at_end ?? false;
            },
            keyById(items) {

                const result = {};
                items.forEach(item => result[item.id] = item);
                return result;
            },
            productMatches(product) {
                return this.productMatchesCategories(product) && this.productMatchesTypes(product) && this.productMatchesRedemptionValidation(product);
            },
            productMatchesCategories(product) {
                return this.filterCategories.length === 0 ||
                    this.venuesById[product.venue_id]?.r_categories?.some(category =>
                        this.filterCategories.some(filterCat => category.id === filterCat.id)
                    );
            },
            productMatchesTypes(product) {
                return this.filterProductTypes.length === 0
                    || this.filterProductTypes.some(filterType => product.product_type_code === filterType.code);
            },
            productMatchesRedemptionValidation(product) {
                return this.filterRedemptionValidation.length === 0
                    || this.filterRedemptionValidation.some(filterRV => product.redemption_validation === filterRV.id);
            },
            dealMatches(deal) {
                return this.filterDeals.length === 0 ||
                    this.filterDeals.some(filterDeal => deal.id === filterDeal.id);
            },
            isNumber (evt) {
                const keyPressed = evt.key;
                if (keyPressed < '0' || keyPressed > '9') {
                    evt.preventDefault()
                }
            },
            sortedProducts(products) {
                //sort products list based on venue name and then on product name
                return products.sort((a, b) => {
                    const venueA = this.allProductsById[a.id]?.venueName || `Venue ${a.venue_id}`;
                    const venueB = this.allProductsById[b.id]?.venueName || `Venue ${b.venue_id}`;
                    const productA = a.name;
                    const productB = b.name;
                    if (venueA < venueB) {
                        return -1;
                    }
                    if (venueA > venueB) {
                        return 1;
                    }
                    if (productA < productB) {
                        return -1;
                    }
                    if (productA > productB) {
                        return 1;
                    }
                    return 0;
                });
              
            }
        },
        computed: {
            allDealsById() {
                return this.keyById(this.alldeals);
            },
            allProductsById() {
                return this.keyById(this.allproducts);
            },
            dealsWithProducts() {
                const deals = this.deals.map(({id, name}) => ({
                    id,
                    name,
                    products: this.allDealsById[id].r_products,
                }));
                deals.push({
                    id: 0,
                    name: 'Individual Items',
                    products: this.products,
                });
                return deals;
            },
            dealsWithProductsFiltered() {
                //sort deals by name

                return this.dealsWithProducts.map(({id, name, products}) => ({
                    id,
                    name,
                    products: products.filter(this.productMatches),
                })).filter(this.dealMatches).filter(deal => deal.products.length).sort((a, b) => {
                    if (a.name < b.name) {
                        return -1;
                    }
                    if (a.name > b.name) {
                        return 1;
                    }
                    return 0;
                });
            },
            allCategories() {
                const categories = {};
                this.dealsWithProducts.forEach(deal =>
                    deal.products.forEach(product =>
                        this.venuesById[product.venue_id]?.r_categories?.forEach(category =>
                            categories[category.id] = category
                        )
                    )
                );
                return Object.values(categories);
            },
            allProductTypes() {
                let types = {};
                this.dealsWithProducts.forEach(deal =>
                    deal.products.forEach(product => {
                        if(product.product_type_code) {
                            types[product.product_type_code] = {
                                'code': product.product_type_code,
                                'name': product.product_type_code,
                            };
                        }
                    })
                );
                types = Object.values(types);
                types.push({
                    'code': null,
                    'name': 'Not Set',
                });
                return types;
            },
            all_checkin_points: {
                get() { return this.rule.settings.default_checkin_points; },
                set(newVal) {
                    this.$set(this.rule.settings, 'default_checkin_points', newVal);
                },
            },
            all_standard_redemptions: {
                get() { return this.rule.settings.default_standard_points; },
                set(newVal) {
                    const settings = this.rule.settings;
                    settings.default_standard_points = newVal;
                    this.$set(this.rule, 'settings', settings);
                },
            },
            venuesById() {
                return this.keyById(this.venues);
            },
        }
    }
</script>